export default __webpack_public_path__ + "static/media/complete_meeting_image.ab817361.svg";